<template>
  <div>
    <router-link
      v-for="staff in staffs"
      :key="staff.adminId"
      v-slot="{ navigate, isActive }"
      :to="{ name: 'StaffEdit', params: { adminId: staff.adminId } }"
      active-class="active"
      custom
    >
      <div
        :class="{ active: isActive }"
        class="staff-item d-flex px-3 py-3"
        @click="navigate"
      >
        <div class="flex-grow-1 flex-shrink-0">
          <div class="staff-meta mb-1">
            <strong>{{ staff.firstName + " " + staff.lastName }}</strong>
          </div>
          <div class="staff-role">
            ตำแหน่ง <strong>{{ (staff.adminRole || {}).roleCode }}</strong>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    staffs: {
      type: Array,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
.staff-item {
  font-size: 16px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;

  &:hover {
    background: #f9f9f9;
  }
  &.active {
    background: #efefef;
  }
}
</style>
